import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ZAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="ZA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={18}
        height={20}
        x={-1}
        y={-4}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M-1-4h18v20H-1z" />
        <Path
          fillRule="evenodd"
          d="M7.714 5 0-1v14l7.714-6H16V5H7.714Z"
          clipRule="evenodd"
        />
      </Mask>
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M7.714 5 0-1v14l7.714-6H16V5H7.714Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        d="m0-1 .614-.79L-1-3.044V-1h1Zm7.714 6-.614.79.271.21h.343V5ZM0 13h-1v2.045l1.614-1.256L0 13Zm7.714-6V6h-.343l-.27.21.613.79ZM16 7v1h1V7h-1Zm0-2h1V4h-1v1ZM0-1l-.614.79 7.714 6L7.714 5l.614-.79-7.714-6L0-1Zm0 14h1V-1h-2v14h1Zm7.714-6L7.1 6.21l-7.714 6L0 13l.614.79 7.714-6L7.714 7ZM16 7V6H7.714v2H16V7Zm0-2h-1v2h2V5h-1ZM7.714 5v1H16V4H7.714v1Z"
        mask="url(#b)"
      />
      <Path
        fill="#272727"
        stroke="#FECA00"
        d="m.3 2.6 4 3 .533.4-.533.4-4 3-.8.6V2l.8.6Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
